import { gsap } from "gsap";
import { useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";

import img from "../assets/asset_3.png";
import img2 from "../assets/asset_4.png";

import TeamCard from "../components/TeamCard";

const Team = () => {
  const [animated, setAnimated] = useState(false);
  const [ref, inView] = useInView({ threshold: 0.2 });

  useEffect(() => {
    if (inView && !animated) {
      let tl = gsap.timeline();

      tl.from("#team-h", {
        stagger: 0.025,
        opacity: 0,
        transform: "scale(0.5) rotate(-5deg)",
      });

      setAnimated(!animated);
    }
  }, [inView]);

  return (
    <div
      ref={ref}
      id="team"
      className="min-vh-100 d-flex flex-column justify-content-center align-items-center text-center"
    >
      <h1 id="team-h" className="primary-h">
        Team
      </h1>
      <br />
      <div className="row justify-content-center">
        <TeamCard
          source={img}
          name={"Rubi Diamond"}
          title={"Co-Founder"}
          twitter={"https://twitter.com/AttractiveBeas1"}
        />
        <TeamCard
          source={img2}
          name={"GBP Pro"}
          title={"Co-Founder"}
          twitter={"https://twitter.com/GBPnftPro"}
        />
      </div>
    </div>
  );
};

export default Team;
